import { Component, computed, inject, input, signal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
    selector: 'app-attachment-preview',
    standalone: true,
    imports: [ButtonModule, DialogModule, TranslocoPipe],
    templateUrl: './attachment-preview.component.html',
    styleUrls: ['./attachment-preview.component.css']
})
export class AttachmentPreviewComponent {
    readonly url = input.required<string>();
    readonly name = input<string>('Attachment');
    readonly visible = signal(false);
    readonly kind = computed<'image' | 'pdf' | 'file'>(() => {
        const name = this.name().split(/[?#]/, 1)[0].toLowerCase();
        const path = this.url().split(/[?#]/, 1)[0].toLowerCase();
        if (/\.(png|jpe?g|gif|webp|bmp|avif)$/.test(name) || /\.(png|jpe?g|gif|webp|bmp|avif)$/.test(path)) return 'image';
        if (name.endsWith('.pdf') || path.endsWith('.pdf')) return 'pdf';
        return 'file';
    });
    readonly previewUrl = computed<SafeResourceUrl | null>(() => {
        if (this.kind() !== 'pdf' || !this.url()) return null;
        try {
            const parsed = new URL(this.url(), window.location.origin);
            return ['https:', 'http:'].includes(parsed.protocol)
                ? this.sanitizer.bypassSecurityTrustResourceUrl(parsed.href)
                : null;
        } catch {
            return null;
        }
    });

    private readonly sanitizer = inject(DomSanitizer);

    open(): void {
        if (this.kind() !== 'file' && (this.kind() !== 'pdf' || this.previewUrl())) this.visible.set(true);
    }
}
